exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".red_shape.small_size{height: auto !important;}\n.mat-dialog-title{line-height: 25px; color:#b50721;}\n.outer_width{width:900px;}\n.mat-select{margin-top: 11px; white-space: nowrap;}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/html/nissco_event_web/angular/src/app/edit-travel/edit-travel.component.css
// module id = ../../../../../src/app/edit-travel/edit-travel.component.css
// module chunks = 39